import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';

/**
 *  Object that defines a user's preferred language and optional region to utilize in their user interface.
 */
class Locale {
    /**
     * Creates a new Locale instance.
     * @param locale Language or language and region (e.g. "en" or "en-US").
     */
    constructor(locale) {
        const parts = locale.split('-');
        this.language = parts[0];
        this.region = parts.length > 1 ? parts[1] : undefined;
    }
    /**
     * Returns the locale as a string.
     * @returns Language and region (e.g. "en-US").
     */
    toString() {
        return this.language + (this.region ? '-' + this.region : '');
    }
}

/**
 * Internationalization service that provides a runtime configurable representation of the user's preferred language & region.
 */
class I18nService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: I18nService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: I18nService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: I18nService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { I18nService, Locale };
